import React, { useState, useEffect } from 'react';
import { Form, Field, FieldWrapper, FormElement } from '@progress/kendo-react-form';
import FormContainer from '../components/FormContainer';
import SubHeader from '../components/SubHeader';
import { CusFormComboBox, CusFormInput, FormComboBox, FormSubTitleDesp, FormSubTitleTooltip, FormTitle, FormUpperCaseInput } from '../validation/Form-Components';
import bizBankingData from '../data/bizbankingservicedata.json'
import { nameOnCardValidator, reqDDLValidator, suffixValidator } from '../validation/Validators';
import TooltipTemplate from '../components/TooltipTemplate';
import { Tooltip } from '@progress/kendo-react-tooltip';
import config from '../appconfig/config.json';
import { useHistory } from "react-router-dom";
import CusProgressBar from '../components/CusProgressBar';
import {Input} from '@progress/kendo-react-inputs';
import service from '../services/ApiService.js';
import sgdaccount from '../data/sgdaccount.json'
import frngaccount from '../data/foreignaccount.json';
import services from '../data/serviceslinkage.json'
import Loading from '../components/Loading';
import BizCardApplicant from './BizCardApplicant';
import helper from '../factory/Helper';
import mandates from '../data/mandate.json';
import AddRemoveBtn from '../components/AddRemoveBtn';
import CardImg from '../images/PlatinumCard1.png';
import '../Card/card-style.css';
import CusToast from '../components/CusToast';
import storage from '../factory/StorageFactory';

const NSBizBankingService = (props) => {
      
    let timer;
    const detailsType='4';
    const history = useHistory();
    const item = { bgcolor: "#389A6E", completed: 50 };
    const seq1=1,seq2=2, seq3=3;
    const authPer0='0';
  
    const [selectedRegAuthUser1,setSelectedRegAuthUser1] = useState({});
    const [selectedRegAuthUser2,setSelectedRegAuthUser2] = useState({});
    const [selectedRegAuthUser3,setSelectedRegAuthUser3] = useState({});

    const [showUserReg1,setShowUserReg1] = useState(true);
    const [showUserReg2,setShowUserReg2] = useState(true);
    const [showUserReg3,setShowUserReg3] = useState(true);
 

    const [selectedBizCardApplicant1, setSelectedBizCardApplicant1]  = useState({});
    const [selectedBizCardApplicant2, setSelectedBizCardApplicant2]  = useState({});
    const [selectedBizCardApplicant3, setSelectedBizCardApplicant3]  = useState({});
  
        
    const [showBizCard1,setShowBizCard1] = useState(true);
    const [showBizCard2,setShowBizCard2] = useState(true);
    const [showBizCard3,setShowBizCard3] = useState(true);

    const [bizNameOnCard,setBizNameOnCard] = useState();
    const [nameOnCard,setNameOnCard] =useState();

    const [showBizReg,setShowBizReg] = useState(true);
    const [isLoading, setIsLoading] = useState(true);  //to show api call
    const [isSaving, setIsSaving] = useState(false);

    const [isError,setIsError] = useState(false);
    const [errMsg, setErrMsg] = useState('');

    const [totalAppDtls, setTotalAppDtls] = useState([]);

    
    const [selectedApplyCheqBook,setSelectedApplyCheqBook] = useState();

    const initResState = {
        CompDtls:{}, 
        ApplicantDtls:[],
        BizAccts:{
            PrefSGDAcct:'',
            PrefFrngAcct:''
        },
        MaybankBussinessPlatinumCard:{
            CompanyNametoAppear: '',
            Applicant:[]
        },
        BizInternetBank:{
            ApprovalMandate:'',   
            AcctLinkList:{
                AcctLinkage:[]
            },
            ServiceLinkList: {
                ServiceLinkage: [],
                UEN: '',
                Suffix:''
            },
            UserRegistration:{
                AuthUser:[{
                    NRIC:'',
                    Seq:''  
                }]
            }
        }
    }

    const [response,setResponse] = useState(initResState);

    const [initFormData, setInitFormData] = useState({   //for Form 
        CompanyNametoAppear:'',
        ApplicantCbo1:'',
        NametoAppear1:'',
        ApplicantCbo2:'',
        NametoAppear2:'',
        ApplicantCbo3:'',
        NametoAppear3:'',

        ApprovalMandate:'',

        UEN:'',
        Suffix:'',

        authUserCbo1:'',
        authUserCbo2:'',
        authUserCbo3:''
    })
     
    useEffect(() => {
        if(helper.isTokenExpired()) {
            history.push(config.route.SessionExpired);
            return;
        }

        if(helper.isInvalidState()) {
            window.location.href = config.link.Cancle;
            return;
        }
        
        window.scrollTo(0,0);
        getData();
        return () => clearTimeout(timer);
    }, []);

    const getData = () => {
        service.get().then( res => {
            if(res.data.isSucess){
                try{
                    bindFormData(res.data.model.fields.request)
                    createTotalAppDtlsArray(res.data.model.fields.request);
                }catch(ex){
                    setIsLoading(false);
                }
            }
            else{
                setIsLoading(false);
            }
        })
        .catch(err => {
           
            setIsLoading(false);
        })
    }

    const bindFormData = (data) => {
        try{
            setResponse(data);
            bindBizCardApplicants(data);
        }catch(ex){
             
        }
    }
    
     //Form Submit
     const handleSubmit = (eve) => {
        if(helper.isTokenExpired()) {
            history.push(config.route.SessionExpired);
            return;
        } 
        
        if(helper.isInvalidState()) {
            window.location.href = config.link.Cancle;
            return;
        }

        if(eve.isValid) {
            let data = JSON.parse(JSON.stringify(eve.values));
            if(validate(data)){

                /* //Mable: item 9
                if(selectedApplyCheqBook === '' || selectedApplyCheqBook === null || selectedApplyCheqBook === undefined) {
                    showErrMsg(config.error.RdoOption);
                    return;
                }
                */
                
                saveBizDetails(formatJsonParams(data));
            }
        }
    }

    const validate = (data) => {
 
        let valid = true;
        if(data.ApprovalMandate.value === undefined) {
            showErrMsg(config.error.BizBankingDetails.SelectApprovalMandate);
            valid= false;
        }
        else if(data.ApprovalMandate.value === mandates[2].value) {
            if(formatAuthUserArray(data).length !== 3){
                showErrMsg(config.error.BizBankingDetails.SelectMin3AuthUser);
                valid= false;
            }
        }
        else if(data.ApprovalMandate.value=== mandates[1].value) {
            if(formatAuthUserArray(data).length < 2){
                showErrMsg(config.error.BizBankingDetails.SelectMin2AuthUser);
                valid= false;
            }
        }
        else if(data.ApprovalMandate.value === mandates[0].value) {
            if(formatAuthUserArray(data).length < 1){
                showErrMsg(config.error.BizBankingDetails.SelectMin1AuthUser);
                valid= false;
            }
        }

        return valid;
    }

    const saveBizDetails = (params) => {
        setIsSaving(true);
        service.post(detailsType,params).then( res=> {
            setIsSaving(false);
            let resData = res.data;
            if(resData.isSucess){
 
                goNext();
            }
            else {
                showErrMsg(config.error.SaveApiFailed);
            }         
        })
        .catch(err => {
            setIsSaving(false);
            showErrMsg(config.error.SaveApiFailed);
        });
     
    }

    const goNext = () => {
        if(history.location.state !== undefined) {
            if(history.location.state.from === config.route.Preview) {
                history.goBack();
            }
        }
        else {
            history.push(config.route.NSDelegationDetails);
        }
    }

    let formatJsonParams = function(data) {
        let params = {
            MaybankBussinessPlatinumCard:{
                CompanyNametoAppear: data.CompanyNametoAppear,
                Applicant:formatApplicatArray(data)
            },
            BizInternetBank:{
                ApprovalMandate:data.ApprovalMandate.value,  //default singly
                AcctLinkList:{
                    AcctLinkage: formatAccountLinkages()
                },
                ServiceLinkList: {
                    ServiceLinkage: [
                        services[0].value,
                        services[1].value,
                        services[2].value,
                        services[3].value,
                        services[4].value,
                        services[5].value,
                        services[6].value,
                        services[7].value,
                        services[8].value,
                        services[9].value
                    ],
                    PaynowRegistration: {
                        Suffix: changeUppercase(data.Suffix)
                    }
                },
                UserRegistration:{
                    AuthUser: formatAuthUserArray(data)
                }
               // ApplyChequeBook:selectedApplyCheqBook   //Mable: item 9
            }
        }
        return params;
    }

    const changeUppercase = (text) => {
        if(text.length < 1){
            return '';
        }
        else {
            return text.toUpperCase();
        }
    }

    let formatAccountLinkages = () => {

        let accLinkages = [];
        accLinkages.push(getValueInArray(response.BizAccts.PrefSGDAcct,sgdaccount));
        accLinkages.push(response.BizAccts.PrefFrngAcct)

        if(getBizPlatinum1() !== null) {
            accLinkages.push(getBizPlatinum1());
        }
        if(getBizPlatinum2() !== null) {
            accLinkages.push(getBizPlatinum2());
        }
        if(getBizPlatinum3() !== null) {
            accLinkages.push(getBizPlatinum3());
        }
        return accLinkages;
    }

    let formatApplicatArray = (data) => {
    
        let applicants = [];
        if(data.ApplicantCbo1){
            if(Object.entries(data.ApplicantCbo1).length !== 0) {
                applicants.push({
                    NRIC:data.ApplicantCbo1.IDNum,
                    Name:data.ApplicantCbo1.Name,
                    NametoAppear: data.NametoAppear1,
                    Seq:seq1
               })
            }
        }
      
        if(data.ApplicantCbo2) {
            if(Object.entries(data.ApplicantCbo2).length !== 0) {
                applicants.push({
                    NRIC:data.ApplicantCbo2.IDNum,
                    Name:data.ApplicantCbo2.Name,
                    NametoAppear: data.NametoAppear2,
                    Seq:seq2
               })
            }
        }
       
        if(data.ApplicantCbo3) {
            if(Object.entries(data.ApplicantCbo3).length !== 0) {
                applicants.push({
                NRIC:data.ApplicantCbo3.IDNum,
                Name:data.ApplicantCbo3.Name,
                NametoAppear: data.NametoAppear3,
                Seq:seq3
                })
            }
       }

        return applicants;
    }

    let formatAuthUserArray = (data) => {

        let authUsers = [];
        if(data.authUserCbo1) {
            if(Object.entries(data.authUserCbo1).length !== 0) {
                authUsers.push({
                    NRIC:data.authUserCbo1.IDNum,
                    Name:data.authUserCbo1.Name,
                    Seq: seq1
               })
            }
        }

        if(data.authUserCbo2) {
            if(Object.entries(data.authUserCbo2).length !== 0) {
                authUsers.push({
                    NRIC:data.authUserCbo2.IDNum,
                    Name:data.authUserCbo2.Name,
                    Seq: seq2
               })
            }
        }

        if(data.authUserCbo3) {
            if(Object.entries(data.authUserCbo3).length !== 0) {
                authUsers.push({
                    NRIC:data.authUserCbo3.IDNum,
                    Name:data.authUserCbo3.Name,
                    Seq: seq3
               })
            }
        }
 
        return authUsers;
    }

    
    const showErrMsg = (msg) => {
        setIsError(true);
        setErrMsg(msg);
        setErrMsgTimeout();
    }

    const setErrMsgTimeout= () => {
        timer = setTimeout(() => {
            setIsError(false);
        }, config.error.msgTimeout);
    }
    
    const getLabelInArray = (iValue, array) => {
        const obj = array.find( ({ value }) => value === iValue);
        let result = '';
        if(obj){
            result = obj.label;
        }
 
        return result;
    }

    const getValueInArray = (iValue, array) => {
        const obj = array.find( ({ value }) => value === iValue);
        let result = '';
        if(obj){
            result = obj.value;
        }
 
        return result;
    }

    const handleShowBizReg = (e) =>{
        e.preventDefault();
        if(showBizReg){
            setShowBizReg(false);
        }
        else{
            setShowBizReg(true);
        }
    }

    const bindBizCardApplicants = (data) => {
        try {
            let formObj = {};
      
            let authDtls = getOnlyAuthorisedAP(data.ApplicantDtls);
    
            let bizCard = data.MaybankBussinessPlatinumCard;
            let bizInternetBank = data.BizInternetBank;
     
            let applicantObj = {}, authUserObj={};
            let appDtlsArray = [], authUsersArray=[];
    
            let applicantSeq1={},applicantSeq2={},applicantSeq3={};
            let authUserSeq1={},authUserSeq2={}, authUserSeq3={};
      
     
            if(bizCard.Applicant && bizInternetBank.UserRegistration.AuthUser) {  // not first time

              setSelectedApplyCheqBook(bizInternetBank.ApplyChequeBook? bizInternetBank.ApplyChequeBook!==null?bizInternetBank.ApplyChequeBook:'':'');

               if(bizCard.Applicant.length === undefined){
                    applicantObj = {
                        Name:bizCard.Applicant.Name,
                        IDNum:bizCard.Applicant.NRIC,
                        NametoAppear:bizCard.Applicant.NametoAppear
                    }
     
                    appDtlsArray.push(applicantObj);
                    applicantSeq1 = applicantObj;
                    setSelectedBizCardApplicant1(applicantSeq1)
               }
               else {
                    for(let i in bizCard.Applicant){
                        applicantObj = {
                            Name:bizCard.Applicant[i].Name,
                            IDNum:bizCard.Applicant[i].NRIC,
                            NametoAppear:bizCard.Applicant[i].NametoAppear
                        }
    
                        if(bizCard.Applicant[i].Seq === '1'){
                            applicantSeq1 = applicantObj;
                            setSelectedBizCardApplicant1(applicantSeq1)
                        }
                        else if(bizCard.Applicant[i].Seq === '2'){
                            applicantSeq2 = applicantObj;
                            setSelectedBizCardApplicant2(applicantSeq2)
                        }
                        else {
                            applicantSeq3 = applicantObj;
                            setSelectedBizCardApplicant3(applicantObj)
                        }
    
                        appDtlsArray.push(applicantObj);
                    }
               }

               if(bizInternetBank.UserRegistration.AuthUser.length === undefined) {
                
                    authUserObj={
                        Name:bizInternetBank.UserRegistration.AuthUser.Name,
                        IDNum:bizInternetBank.UserRegistration.AuthUser.NRIC
                    }
                    authUsersArray.push(authUserObj);
                    authUserSeq1 = authUserObj;
                    setSelectedRegAuthUser1(authUserSeq1)
    
               }
               else {
                    for(let i in bizInternetBank.UserRegistration.AuthUser){
                        authUserObj = {
                            Name:bizInternetBank.UserRegistration.AuthUser[i].Name,
                            IDNum:bizInternetBank.UserRegistration.AuthUser[i].NRIC
                        }
    
                        if(bizInternetBank.UserRegistration.AuthUser[i].Seq === '1'){
                            authUserSeq1 = authUserObj;
                            setSelectedRegAuthUser1(authUserSeq1)
                        }
                        else if(bizInternetBank.UserRegistration.AuthUser[i].Seq === '2'){
                            authUserSeq2 = authUserObj;
                            setSelectedRegAuthUser2(authUserSeq2)
                        }
                        else if(bizInternetBank.UserRegistration.AuthUser[i].Seq === '3'){
                            authUserSeq3 = authUserObj;
                            setSelectedRegAuthUser3(authUserSeq3)
                        }
    
                        authUsersArray.push(authUserObj);
                    }
               }
    
               formObj = {
                   CompanyNametoAppear:bizCard.CompanyNametoAppear !==null? bizCard.CompanyNametoAppear:'',
                   UEN:data.CompDtls.RegNo!==null? data.CompDtls.RegNo:'',
                   Suffix:bizInternetBank.ServiceLinkList.PaynowRegistration? bizInternetBank.ServiceLinkList.PaynowRegistration.Suffix? bizInternetBank.ServiceLinkList.PaynowRegistration.Suffix:'':'',
                   ApprovalMandate:bindApprovalMandate(data),
                   ApplicantCbo1: applicantSeq1,
                   ApplicantCbo2: applicantSeq2,
                   ApplicantCbo3: applicantSeq3,
                   authUserCbo1: authUserSeq1,
                   authUserCbo2: authUserSeq2,
                   authUserCbo3: authUserSeq3
               }
               setBizCardDisplay(appDtlsArray);
               setUserRegDisplay(authUsersArray);
               bindInitFormData(formObj)
            }
            else {  //first time
                //bind from ApplicantDtls Array
                console.log('first time');
                if(!Array.isArray(authDtls)) {  //object
             
                    applicantObj = {
                        Name:authDtls.Name,
                        IDNum:authDtls.IDNum,
                        NametoAppear:authDtls.Name
                    }
                    appDtlsArray.push(applicantObj);
                    applicantSeq1 = applicantObj;
                    setSelectedBizCardApplicant1(applicantSeq1)
                    setSelectedRegAuthUser1(applicantSeq1)
                }
                else { //array
                    for(let i in authDtls){
                        applicantObj = {
                            Name:authDtls[i].Name,
                            IDNum:authDtls[i].IDNum,
                            NametoAppear:authDtls[i].Name
                        }
    
                        if(authDtls[i].ApplicantSeq === '1'){
                            if(authDtls[i].Authorised === undefined || authDtls[i].Authorised === 'true') {
                                applicantSeq1 = applicantObj;
                                setSelectedBizCardApplicant1(applicantSeq1)
                                setSelectedRegAuthUser1(applicantSeq1)
                            }
                        }
                        else if(authDtls[i].ApplicantSeq === '2'){
                            if(authDtls[i].Authorised === undefined || authDtls[i].Authorised === 'true') { 
                                applicantSeq2 = applicantObj;
                                setSelectedBizCardApplicant2(applicantSeq2)
                                setSelectedRegAuthUser2(applicantSeq2)
                            }
                        }
                        else {
                            if(authDtls[i].Authorised === undefined || authDtls[i].Authorised === 'true') { 
                                applicantSeq3 = applicantObj;
                                setSelectedBizCardApplicant3(applicantObj)
                                setSelectedRegAuthUser3(applicantObj)
                            }
                        }
                        appDtlsArray.push(applicantObj);
                    }
                }
    
                formObj = {
                    CompanyNametoAppear:data.CompDtls.CompName,
                    UEN:data.CompDtls.RegNo,
                    Suffix:'',
                    ApprovalMandate:bindApprovalMandate(data),
                    ApplicantCbo1: applicantSeq1,
                    ApplicantCbo2: applicantSeq2,
                    ApplicantCbo3: applicantSeq3,
                    authUserCbo1: applicantSeq1,
                    authUserCbo2: applicantSeq2,
                    authUserCbo3: applicantSeq3
                }
    
                setBizCardDisplay(appDtlsArray);
                setUserRegDisplay(appDtlsArray);
                bindInitFormData(formObj)
            }
 

        }catch(ex){

        }
      
    }

    const bindInitFormData = (data) => {
      
        setInitFormData({ 
            CompanyNametoAppear:subStrCompNametoAppear(data.CompanyNametoAppear),  //data.CompanyNametoAppear
            ApplicantCbo1:data.ApplicantCbo1,
            NametoAppear1:subStrNametoAppear(data.ApplicantCbo1.NametoAppear), //subStrNametoAppear(data.ApplicantCbo1.NametoAppear)
            ApplicantCbo2:data.ApplicantCbo2,
            NametoAppear2:subStrNametoAppear(data.ApplicantCbo2.NametoAppear),
            ApplicantCbo3:data.ApplicantCbo3,
            NametoAppear3:subStrNametoAppear(data.ApplicantCbo3.NametoAppear),
    
            ApprovalMandate: data.ApprovalMandate,
    
            UEN:data.UEN,
            Suffix:data.Suffix,
    
            authUserCbo1:data.authUserCbo1,
            authUserCbo2:data.authUserCbo2,
            authUserCbo3:data.authUserCbo3
        })
        setBizNameOnCard(subStrCompNametoAppear(data.CompanyNametoAppear));
        setNameOnCard(subStrNametoAppear(data.ApplicantCbo1.NametoAppear));
        setSelectedBizCardApplicant1(data.ApplicantCbo1);
        setSelectedRegAuthUser1(data.authUserCbo1);
        setIsLoading(false);
    }

    const subStrCompNametoAppear = (compNametoAppear) => {
        let str = '';
        if(compNametoAppear === undefined || compNametoAppear === null || compNametoAppear === '') {
            return str;
        }
        else {
            let tempStr = compNametoAppear.replace(/[^a-zA-Z0-9\-.,'/&/\s]/g, "");
            if(tempStr.length > 19) {
                str = tempStr.substring(0,19);
            }
            else {
                str = tempStr;
            }
        }
        return str;
    }

    const subStrNametoAppear = (nametoAppear) => {
      
        let str = '';
        if(nametoAppear === undefined || nametoAppear === null || nametoAppear === ''){
            return str;
        }
        else {
            let tempStr = nametoAppear.replace(/[^a-zA-Z0-9\-.\s]/g, "");
            
            if(tempStr.length > 19) {
                str = tempStr.substring(0,19);
            }
            else {
                str = tempStr;
            }
        }
         
        return str;
    }

    const bindApprovalMandate = (data) => {
 
        let mandateObj = {}
        if(data.BizInternetBank && data.BizInternetBank.ApprovalMandate && data.BizInternetBank.ApprovalMandate !== null) { 
         
            mandateObj = helper.getObjInArray(data.BizInternetBank.ApprovalMandate,mandates);
        }
        else {
            //first time, before save
            // if(data.ApplicantDtls.length === undefined || data.ApplicantDtls.length === 1) {
            //     mandateObj = mandates[0];
            // }
            // else if(data.ApplicantDtls.length === 2) {
            //     mandateObj = mandates[1];
            // }
            // else if(data.ApplicantDtls.length === 3) {
            //     mandateObj = mandates[2];
            // }
        }
        return mandateObj;
    }

    const createTotalAppDtlsArray = (data) => {
        let array = [];
        if(data.ApplicantDtls.length === undefined){
            array.push(data.ApplicantDtls);
            setTotalAppDtls(array);
        }
        else {
            for(let i in data.ApplicantDtls) {
                if(data.ApplicantDtls[i].ApplicantSeq !== authPer0){
                    if(data.ApplicantDtls[i].Authorised === undefined ||data.ApplicantDtls[i].Authorised === 'true') {
                        array.push(data.ApplicantDtls[i]);
                    }
                }
            }
            setTotalAppDtls(array);
        }
    }

    const createMandatesArray = () => {
        let appDtlsArray = getOnlyAuthorisedAP(response.ApplicantDtls);
        let manArray = [];
        if(appDtlsArray.length === undefined || appDtlsArray.length === 1) {
            manArray.push(mandates[0]);
        }
        else if(appDtlsArray.length===2) {
            manArray.push(mandates[0]);
            manArray.push(mandates[1]);
        }
        else {
            manArray = mandates;
        }

        return manArray;
    }

    const getOnlyAuthorisedAP = (applicantDtls) => {
        let temp = [];
        if(!Array.isArray(applicantDtls)){
            temp.push(applicantDtls);
        }
        else {
            for(let i in applicantDtls){
                if(applicantDtls[i].Authorised === undefined || applicantDtls[i].Authorised === 'true') {
                    temp.push(applicantDtls[i]);
                }
            }
        }

        return temp;
    }
 
    const getBizPlatinum1 = () => {
        if(selectedBizCardApplicant1 && selectedBizCardApplicant1.IDNum ){
            return "Business Platinum Visa Debit Card (for Authorised User 1 "+selectedBizCardApplicant1.Name+")";
        }
        return null;
    }

    const getBizPlatinum2 = () => {
        if(selectedBizCardApplicant2 && selectedBizCardApplicant2.IDNum ){
            return "Business Platinum Visa Debit Card (for Authorised User 2 "+selectedBizCardApplicant2.Name+")";
        }
        return null;
    }

    const getBizPlatinum3 = () => {
        if(selectedBizCardApplicant3 && selectedBizCardApplicant3.IDNum ){
            return "Business Platinum Visa Debit Card (for Authorised User 3 "+selectedBizCardApplicant3.Name+")";
        }
        return null;
    }

    const setBizCardDisplay = (array) => {
    
        if(seq1 == array.length) {
            setShowBizCard1(true);
            setShowBizCard2(false);
            setShowBizCard3(false);
        }

        if(seq2 === array.length ) {
            setShowBizCard1(true);
            setShowBizCard2(true);
            setShowBizCard3(false);
        }

        if(seq3 === array.length ) {
            setShowBizCard1(true);
            setShowBizCard2(true);
            setShowBizCard3(true);
        }
    }

    const setUserRegDisplay = (array) => {
        if(seq1 == array.length) {
            setShowUserReg1(true);
            setShowUserReg2(false);
            setShowUserReg3(false);
        }
        
        if(seq2 === array.length ) {
            setShowUserReg1(true);
            setShowUserReg2(true);
            setShowUserReg3(false);
        }

        if(seq3 === array.length ) {
            setShowUserReg1(true);
            setShowUserReg2(true);
            setShowUserReg3(true);
        }
    }

    const handleBackBtnClick = (e) => {
        e.preventDefault();
        
        if(storage.getSHSaved() !== undefined && storage.getSHSaved() === 'true'){
            history.push(config.route.ShareholdersDetails);
        }
        else {
            history.push(config.route.NSApplicantDetails);
        }
   
    //   history.goBack();
    }

    const showBizCardAddRemoveBtn1 = () => {
        if(showBizCard1) {
            if(totalAppDtls.length > seq1) { //check the length of applicant details array
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }

    const showUserRegAddRemoveBtn1 = () =>{
        if(showUserReg1) {
            if(totalAppDtls.length > seq1) { //check the length of applicant details array
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }

    const showBizCardAddRemoveBtn2 = () => {
        if(showBizCard2) {
            if(totalAppDtls.length > seq2) { //check the length of applicant details array
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }

    const showUserRegAddRemoveBtn2 = () =>{
        if(showUserReg2) {
            if(totalAppDtls.length > seq2) { //check the length of applicant details array
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }

    if(isLoading) {
        return(
            <Loading />
        )
    }

    return(
        <div className="container-fluid">
               <SubHeader /><br/>
               <Form onSubmitClick={handleSubmit} 
                initialValues={initFormData}
                key ={JSON.stringify(initFormData)}
                render={(formRenderProps) => (
                    <FormElement>
                        <FormContainer>
                            <fieldset>
                                <Field component={FormTitle} 
                                    id={bizBankingData.formContainerTitle.T1} 
                                    name={bizBankingData.formSubTitle.ST1} />
 
                                <Field component={FormSubTitleDesp} id={'fstSTD1'} 
                                    name={bizBankingData.note}  />
                                <FieldWrapper>
                                <div className="row around-xs inputPair elementVisible">
                                    <div className="cardImgCenter cardWidth">
                                        <div className="cardContainer">
                                        <img src={CardImg} alt="myimage" />
                                        <div className="cardBizLabel cardTxt">{nameOnCard}</div> 
                                        <div className="cardUserLabel cardTxt">{bizNameOnCard}</div>
                                        </div>
                                    </div>
                                </div>
                                </FieldWrapper>

                                <FieldWrapper>
                                    <Field component={CusFormInput} 
                                        leftLabelId={'lblcoName'} leftLabelName={bizBankingData.label.coNameOnCard} 
                                        placeholder={'Please input (19 characters in total)'}
                                        id={'CompanyNametoAppear'} name={'CompanyNametoAppear'} 
                                        maxLength={19} 
                                        validator={nameOnCardValidator}
                                        onChange={(e)=>{
                                            setBizNameOnCard(e.value);
                                        }} />
                                </FieldWrapper>

                                {showBizCard1 &&
                                <BizCardApplicant seq={seq1}
                                    cboTxtField={'Name'} 
                                    cboData={totalAppDtls} 
                                    maxlength={19}
                                    onCboChange={e =>{
                                        if(e.value === null)  return;
                                        setSelectedBizCardApplicant1(e.value)}} 
                                    displayAddRemoveBtn={showBizCard3? false: showBizCardAddRemoveBtn1()}
                                    defBtnValue={!showBizCard2}
                                    AddBtnOnClick={()=>{ setShowBizCard2(true);}}
                                    RemoveBtnOnClick={()=>{
                                        formRenderProps.onChange('ApplicantCbo'+seq2,'');
                                        formRenderProps.onChange('NametoAppear'+seq2,'');
                                        setSelectedBizCardApplicant2({});
                                        setShowBizCard2(false);
                                    }} 
                                    onInputChange={(v,id)=>{ setNameOnCard(v)}}
                                    /> }


                                {showBizCard2 &&
                                <BizCardApplicant seq={seq2}
                                    cboTxtField={'Name'} 
                                    maxlength={19}
                                    cboData={helper.filterArrayByName(totalAppDtls,selectedBizCardApplicant1.Name)} 
                                    onCboChange={e=>{
                                        if(e.value === null)  return;
                                        setSelectedBizCardApplicant2(e.value)}} 
                                        displayAddRemoveBtn={showBizCardAddRemoveBtn2()}
                                        defBtnValue={!showBizCard3}
                                        AddBtnOnClick={()=>{setShowBizCard3(true)}}
                                        RemoveBtnOnClick={()=>{
                                        formRenderProps.onChange('ApplicantCbo'+seq3,'');
                                        formRenderProps.onChange('NametoAppear'+seq3,'');
                                        setSelectedBizCardApplicant3({});
                                        setShowBizCard3(false);
                                    }} 
                                    onInputChange={(v,id)=>{}} />}
                                
                                {showBizCard3 &&
                                <BizCardApplicant seq={seq3} maxlength={19}
                                    cboData={helper.filterArrayByName(helper.filterArrayByName(totalAppDtls,selectedBizCardApplicant1.Name),selectedBizCardApplicant2.Name)} 
                                    cboTxtField={'Name'} 
                                    onCboChange={e=>{
                                        if(e.value === null)  return;
                                        setSelectedBizCardApplicant3(e.value)}}
                                        displayAddRemoveBtn={false}
                                        defBtnValue={false}
                                        AddBtnOnClick={()=>{}}
                                        RemoveBtnOnClick={()=>{} } 
                                        onInputChange={(v,id)=>{}}
                                    /> }

                                <FieldWrapper></FieldWrapper>
                              
                            </fieldset>
                        </FormContainer>
                        <FormContainer>
                            <fieldset>
                                <Field component={FormTitle} 
                                    id={bizBankingData.formContainerTitle.T2} 
                                    name={bizBankingData.formContainerTitle.T2.name} /> 
 
                                <FieldWrapper>
                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <div id={'fstST2'} style={{float:'left'}}>{bizBankingData.formSubTitle.ST2}</div>
                                    <div style={{float:'right'}} onClick={handleShowBizReg}>
                                        {showBizReg?
                                            <span className="k-space-right" style={{fontSize: "11px"}}>
                                            Hide 
                                            &nbsp;<span className="k-icon k-i-arrow-chevron-up" />
                                            </span> :
                                        <span className="k-space-right" style={{fontSize: "11px"}}>
                                            Show  
                                            &nbsp;<span className="k-icon k-i-arrow-chevron-down" />
                                        </span>}
                                    </div>
                                    </div>
                                </div>
                                </FieldWrapper>
                            
                                {showBizReg &&
                                <FieldWrapper>
                                <div className="row around-xs inputPair elementVisible">
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                    <div className="box" id={'lblapprovalM'} style={{ marginTop: "5px" }}>
                                        <div style={{width:'70%', float:"left"}}><span>{bizBankingData.label.approvalM}</span></div>
                                            <div style={{width:'30%', float:"left"}}>
                                            <Tooltip id={'ttapprovalM'} content={(props) => 
                                                <TooltipTemplate id={'tttapprovalM'} title={props.title}/>} 
                                                    anchorElement={'target'} position={'right'} >
                                                    <span className="k-icon k-i-information" title={bizBankingData.tooltip.approvalMan}></span> 
                                            </Tooltip></div>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                    <div className="box">
                                        <Field component={FormComboBox} 
                                            id={'ApprovalMandate'} 
                                            name={'ApprovalMandate'} 
                                            textField={'label'} 
                                            clearButton={true}
                                            data={createMandatesArray()}
                                            placeholder={'Please select'}
                                            validator={reqDDLValidator}
                                            onChange={e =>{
                                            if(e.value === null){
                                                return;
                                            }
                                        }}/>
                                    </div> 
                                </div>
                                </div>
                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                        <div className="box" id={'lblaccLinkage'}  style={{ marginTop: "5px" }}>
                                            <div style={{width:'70%', float:"left"}}><span>{bizBankingData.label.accLinkage}</span></div>
                                            <div style={{width:'30%', float:"left"}}>
                                            <Tooltip id={'ttAccLinkage'} content={(props) => 
                                                <TooltipTemplate id={'tttAccLinkage'} title={props.title}/>} 
                                                    anchorElement={'target'} position={'right'} >
                                                    <span className="k-icon k-i-information" title={bizBankingData.tooltip.accLinkage}></span> 
                                            </Tooltip></div>
                                        </div>
                                        </div>
                                        <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6" >
                                            <div className="box" style={{ marginTop: "5px", width:"100%" }}> 
                                                <span style={{height:'5px',width:'5px',backgroundColor:'black',borderRadius:'50%', display:'inline-block'}} /> 
                                                &nbsp;<label>{getLabelInArray(response.BizAccts.PrefSGDAcct, sgdaccount)} </label> 
                                            </div>
                                            {response.BizAccts.PrefFrngAcct !== null && <div  className="box" style={{ width:"100%" }}> 
                                                <span style={{height:'5px',width:'5px',backgroundColor:'black',borderRadius:'50%', display:'inline-block'}} /> 
                                                &nbsp;<label>{response.BizAccts.PrefFrngAcctDesc}</label> 
                                            </div>}
                                            
                                            {getBizPlatinum1()!==null&&
                                            <div  className="box" style={{ width:"100%" }}>
                                                <span style={{height:'5px',width:'5px',backgroundColor:'black',borderRadius:'50%', display:'inline-block'}} /> 
                                                &nbsp;<label>Business Platinum Visa Debit Card </label> <br/>
                                                <label style={{paddingLeft:'10px'}}>(for Authorised User 1 {selectedBizCardApplicant1.Name})</label>
                                            </div>}
                                            
                                            {getBizPlatinum2()!==null&&
                                            <div className="box" style={{ width:"100%" }}>
                                                <span style={{height:'5px',width:'5px',backgroundColor:'black',borderRadius:'50%', display:'inline-block'}} /> 
                                                &nbsp;<label>Business Platinum Visa Debit Card</label> <br/>
                                                <label style={{paddingLeft:'10px'}}>(for Authorised User 2 {selectedBizCardApplicant2.Name})</label>
                                            </div>}
                                        
                                            {getBizPlatinum3()!==null&&
                                            <div className="box" style={{ width:"100%" }}>
                                                <span style={{height:'5px',width:'5px',backgroundColor:'black',borderRadius:'50%', display:'inline-block'}} /> 
                                                &nbsp;<label>Business Platinum Visa Debit Card</label>  <br/>
                                                <label style={{paddingLeft:'10px'}}>(for Authorised User 3 {selectedBizCardApplicant3.Name})</label>
                                            </div>}

                                        </div>
                                </div>

                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                        <div className="box" id={'lblaccLinkage'}  style={{ marginTop: "5px" }}>
                                            <div style={{width:'70%', float:"left"}}><span>{bizBankingData.label.serLinkage}</span></div>
                                            <div style={{width:'30%', float:"left"}}>
                                            <Tooltip id={'ttserLinkage'} content={(props) => 
                                                    <TooltipTemplate id={'tttserLinkage'} title={props.title}/>} 
                                                        anchorElement={'target'} position={'right'} >
                                                        <span className="k-icon k-i-information" title={bizBankingData.tooltip.serLinkage}></span> 
                                            </Tooltip></div>
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6" >
                                        <div className="box" style={{ marginTop: "5px", width:"100%" }}>
                                            <span style={{height:'5px',width:'5px',backgroundColor:'black',borderRadius:'50%', display:'inline-block'}} /> 
                                            &nbsp; 
                                            <label>{services[0].label}</label> 
                                        </div>
                                        <div className="box" style={{ width:"100%" }}>
                                            <span style={{height:'5px',width:'5px',backgroundColor:'black',borderRadius:'50%', display:'inline-block'}} /> 
                                            &nbsp; 
                                            <label>{services[1].label}</label> 
                                        </div>
                                        <div>
                                            <span style={{height:'5px',width:'5px',backgroundColor:'black',borderRadius:'50%', display:'inline-block'}} /> 
                                            &nbsp;<label>Bulk Payment/Collection</label> 
                                            <label style={{paddingLeft:'10px'}}>(Inward/Outward GIRO) </label> 
                                        </div>
                                        <div  className="box" style={{ width:"100%" }}> 
                                            <span style={{height:'5px',width:'5px',backgroundColor:'black',borderRadius:'50%', display:'inline-block'}} /> 
                                            &nbsp;<label>{services[3].label}</label> 
                                        </div>
                                        <div  className="box" style={{ width:"100%" }}>
                                            <span style={{height:'5px',width:'5px',backgroundColor:'black',borderRadius:'50%', display:'inline-block'}} /> 
                                            &nbsp;<label>{services[4].label}</label> 
                                        </div>
                                        <div  className="box" style={{ width:"100%" }}>
                                            <span style={{height:'5px',width:'5px',backgroundColor:'black',borderRadius:'50%', display:'inline-block'}} /> 
                                            &nbsp;<label>{services[5].label}</label> 
                                        </div>
                                        <div className="box" style={{ width:"100%" }}>
                                            <span style={{height:'5px',width:'5px',backgroundColor:'black',borderRadius:'50%', display:'inline-block'}} /> 
                                            &nbsp;<label>{services[6].label}</label> 
                                        </div>
                                        <div className="box" style={{ width:"100%" }}>
                                            <span style={{height:'5px',width:'5px',backgroundColor:'black',borderRadius:'50%', display:'inline-block'}} /> 
                                            &nbsp;<label>{services[7].label}</label> 
                                        </div>
                                        <div className="box" style={{width:"100%"}}>
                                            <span style={{float:"left",paddingRight:"10px"}}>
                                            <span style={{height:'5px',width:'5px',backgroundColor:'black',borderRadius:'50%', display:'inline-block'}} /> 
                                            &nbsp;<label >{services[8].label}</label></span>
                                            <Tooltip content={(props) => 
                                                <TooltipTemplate title={props.title}/>} 
                                                    anchorElement={'target'} position={'right'} >
                                                    <span className="k-icon k-i-information" title={bizBankingData.tooltip.paynow}></span> 
                                            </Tooltip>
                                        </div>
                                        <div className="box row" style={{ width:"100%" }}>
                                            <div className="paynow-txt">
                                                <Input name={'UEN'} placeholder={'UEN'} disabled={true} value={response.CompDtls.RegNo !== null? response.CompDtls.RegNo :''} /> 
                                            </div>
                                            <div className="suffix-txt">
                                                <Field component={FormUpperCaseInput} placeholder={'Suffix(Optional)'} id={'Suffix'} name={'Suffix'} maxLength={3} validator={suffixValidator}/>
                                            </div>
                                        </div>
                                        <div className="box" style={{ width:"100%",paddingTop:'10px'}}>
                                            <span style={{height:'5px',width:'5px',backgroundColor:'black',borderRadius:'50%', display:'inline-block'}} /> 
                                            &nbsp;<label>{services[9].label}</label> 
                                        </div>
                                    </div>
                                </div>
 
                                <div> <hr className="greyPanelLine" /> </div>
                                
                                </FieldWrapper> }

                                <Field component={FormSubTitleTooltip} 
                                     id={'fstST3'} name={bizBankingData.formSubTitle.ST3}
                                    tooltipPosition={'right'} tooltipAchor={'target'} 
                                    tooltipTitle={bizBankingData.tooltip.ST3}/>
                                <FieldWrapper>

                                {showUserReg1 && 
                                <Field component={CusFormComboBox} 
                                    leftLabelId={'lblAuthUser'+seq1} leftLabelName={bizBankingData.label.dcApplicant+' '+seq1} 
                                    textField={'Name'}
                                    data={totalAppDtls}
                                    placeholder={'Please select'}
                                    id={'authUserCbo'+seq1} 
                                    name={'authUserCbo'+seq1} 
                                    onChange={e=>{
                                        if(e.value === null)  return;
                                        setSelectedRegAuthUser1(e.value)
                                    }}/> }

                                {showUserReg3? false: showUserRegAddRemoveBtn1() &&
                                 <AddRemoveBtn defBtnValue={!showUserReg2} seq={seq2} label={'Add another authorised user'} disabled={false}
                                        onClick={(v)=>{
                                            if(v==='Remove'){
                                                formRenderProps.onChange('authUserCbo'+seq2,'');
                                                setShowUserReg2(false); 
                                            }else {
                                                setShowUserReg2(true); 
                                            }
                                    }} />}

                                {showUserReg2 && 
                                <Field component={CusFormComboBox} 
                                    leftLabelId={'lblAuthUser'+seq2} leftLabelName={bizBankingData.label.dcApplicant+' '+seq2} 
                                    textField={'Name'}
                                    data={helper.filterArrayByName(totalAppDtls,selectedRegAuthUser1.Name)}
                                    placeholder={'Please select'}
                                    id={'authUserCbo'+seq2} 
                                    name={'authUserCbo'+seq2} 
                                    onChange={e=>{
                                        if(e.value === null)  return;
                                        setSelectedRegAuthUser2(e.value)
                                    }}/> }
                          
                                {showUserRegAddRemoveBtn2() && 
                                <AddRemoveBtn defBtnValue={!showUserReg3} seq={seq3} label={'Add another authorised user'} disabled={false}
                                        onClick={(v)=> {
                                            if(v==='Remove'){
                                                formRenderProps.onChange('authUserCbo'+seq3,'');
                                                setShowUserReg3(false);
                                            }else {
                                                setShowUserReg3(true);
                                            }
                                   }} />}
                                
                                {showUserReg3 && 
                                    <Field component={CusFormComboBox} 
                                        leftLabelId={'lblAuthUser'+seq3} leftLabelName={bizBankingData.label.dcApplicant+' '+seq3} 
                                        textField={'Name'}
                                        data={helper.filterArrayByName(helper.filterArrayByName(totalAppDtls,selectedRegAuthUser1.Name),selectedRegAuthUser2.Name)}
                                        placeholder={'Please select'}
                                        id={'authUserCbo'+seq3} 
                                        name={'authUserCbo'+seq3} 
                                        onChange={e => { 
                                            if(e.value === null)  return;
                                            setSelectedRegAuthUser3(e.value)
                                        }}/> }
                                        
                                </FieldWrapper>
                      
                        <FieldWrapper>

                        <CusProgressBar bgcolor={item.bgcolor} completed={item.completed} /> 

                        <div className="row around-xs inputPair elementVisible">
                            <div  className="col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{ paddingBottom: "20px" }}>
                                <button type={"button"} className="btn btn-back" onClick={handleBackBtnClick}>{config.btnName.Back}</button>
                                <button type={'submit'} className="k-button btn btn-success btn-float-right" disabled={!formRenderProps.valid}>{config.btnName.Next}</button>
                            </div>
                        </div> 
                        </FieldWrapper>
                        
                        <CusToast className="popUpBox" trigger={isError} setTrigger={setIsError} label={errMsg} timer={timer} /> 
                        </fieldset>
                        </FormContainer>
                    </FormElement>
                )}>
             
               </Form>
               {isSaving && <Loading />} 
        </div>
    )

}

export default NSBizBankingService